import firebase from "firebase/app";

import db from "@/db";
import utils from "@/utils";

export default {
  namespaced: true,
  state: {
    initialized: false,
    update: {},
    goals: [],
    nextGoals: [],
    historical: [],
  },
  mutations: {
    setUpdate(state, update) {
      state.update = update;
      state.initialized = true;
    },
    setGoals(state, goals) {
      state.goals = [...goals];
    },
    setNextGoals(state, goals) {
      state.nextGoals = [...goals];
    },
    // TODO - DEAL WITH GOALS BREAKOUT
    setHistorical(state, historical) {
      state.historical = historical;
    },
  },
  actions: {
    // RENAME TO LISTEN?
    // TODO - REACT TO DAY CHANGES
    async loadAndListen({ commit }) {
      db.doc(`updates/${utils.getWeekId()}`).onSnapshot((snap) => {
        const update = snap.data() || {};
        commit("setUpdate", update);
      });
      // CURRENT GOALS
      db.collection(`updates/${utils.getWeekId()}/goals`).onSnapshot((snap) => {
        const goals = db.snapshotToArray(snap).sort((a, b) => {
          if (a.status !== b.status) {
            return a.status === "DONE" ? -1 : 1;
          }
          return a._created.seconds - b._created.seconds;
        });
        commit("setGoals", goals);
      });
      // NEXT GOALS
      db.collection(`updates/${utils.getNextWeekId()}/goals`).onSnapshot(
        (snap) => {
          const goals = db
            .snapshotToArray(snap)
            .sort((a, b) => a._created.seconds - b._created.seconds);
          commit("setNextGoals", goals);
        }
      );
    },
    async loadHistorical({ commit }) {
      // TODO - UPDATE TO ADD GOALS
      const currentWeeks = [utils.getWeekId(), utils.getNextWeekId()];
      const historicalRef = await db.collection("updates").get();
      const historical = db
        .snapshotToArray(historicalRef)
        .filter((update) => !currentWeeks.includes(update.id));
      commit("setHistorical", historical);
    },
    // eslint-disable-next-line
    async setUpdate({ state }, update) {
      if (!state.initialized) {
        return console.log("HOLD YOUR HORSES, WE ARE STILL WARMING UP!");
      }
      try {
        // TODO - SIGNAL SUCCESS
        await db
          .doc(`updates/${utils.getWeekId()}`)
          .set({ ...update, _updated: new Date() }, { merge: true });
      } catch (e) {
        console.error(e);
      }
    },
    async setSummary({ dispatch }, summary) {
      // TODO - SIGNAL SUCCESS
      return dispatch("setUpdate", { summary });
    },
    async setQuestion({ dispatch }, question = "") {
      // Delete the field so the email template doesn't render blank questions
      if (!question || !question.length) {
        return dispatch("setUpdate", {
          question: firebase.firestore.FieldValue.delete(),
        });
      }
      // TODO - SIGNAL SUCCESS
      return dispatch("setUpdate", { question });
    },
    // eslint-disable-next-line
    async addGoal({}, { goal, weekId }) {
      // TODO - SIGNAL SUCCESS
      try {
        await db.collection(`updates/${weekId}/goals`).add({
          goal,
          status: "PENDING",
          _updated: new Date(),
          _created: new Date(),
        });
      } catch (e) {
        // TODO - SHOW ERROR TO USER
        console.error(e);
      }
    },
    // eslint-disable-next-line
    async updateGoal({}, { goalId, weekId, payload }) {
      // TODO - SIGNAL SUCCESS
      // TODO - DON'T MAKE THE CALL IF NOTHING HAS CHANGED?
      try {
        await db
          .doc(`updates/${weekId}/goals/${goalId}`)
          .set({ ...payload, _updated: new Date() }, { merge: true });
      } catch (e) {
        // TODO - SHOW ERROR TO USER AND LOG TO SENTRY
        console.error(e);
      }
    },
    // eslint-disable-next-line
    async deleteGoal({}, { goalId, weekId }) {
      // TODO - SIGNAL SUCCESS
      try {
        await db.doc(`updates/${weekId}/goals/${goalId}`).delete();
      } catch (e) {
        // TODO - SHOW ERROR TO USER AND LOG TO SENTRY
        console.error(e);
      }
    },
  },
};
